module.exports = __webpack_public_path__ + "img/plane.1a2d4153.svg";